import { render, staticRenderFns } from "./BlockImageText.vue?vue&type=template&id=8fa8abc2&"
import script from "./BlockImageText.vue?vue&type=script&lang=js&"
export * from "./BlockImageText.vue?vue&type=script&lang=js&"
import style0 from "./BlockImageText.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports